<template>
    <div class="wrap-input"
        :class="customClass">
        <div class="input-label"> 
            {{label}}
            <span v-if="isRegister" class="text-req">*</span><span v-if="isRegister" class="text-warning-register">{{warning}}</span>
            <span v-if="notice" class="text-notice">
                <span class="star">*</span>
                <span class="notice">{{notice}}</span>
            </span>
        </div>
        <div class="wrap-row-ddl"
            :class="{'wrap-row-ddl-error': isShowError && isSubmitted && !errorInfo.isValid}"
            v-if="isInitSuccess && !isHaveBirthdate">
            <div class="wrap-ddl"
                v-if="isShowDay">
                <InputDropdown
                    :addClass="customClass"
                    :errorInfo="errorInfoDay"
                    inputId="birthdate_day"
                    :inputLbl="inputLbl.day"
                    :isSubmitted="isSubmitted"
                    :itemList="dayList" 
                    :isDisabled="isDisabled"
                    v-model="dayInput"
                    @input="onDayChange($event)" />
            </div>
            <div class="wrap-ddl">
                <InputDropdown
                    :addClass="customClass"
                    :errorInfo="errorInfoMonth"
                    inputId="birthdate_month"
                    :inputLbl="inputLbl.month"
                    :isSubmitted="isSubmitted"
                    :itemList="monthList"
                    :isDisabled="isDisabled"
                    v-model="monthInput"
                    @input="onMonthChange($event)" />
            </div>
            <div class="wrap-ddl">
                <InputDropdown
                    :addClass="customClass"
                    :errorInfo="errorInfoYear"
                    inputId="birthdate_year"
                    :inputLbl="inputLbl.year"
                    :isSubmitted="isSubmitted"
                    :isDisabled="isDisabled"
                    :itemList="yearList"
                    v-model="yearInput"
                    @input="onYearChange($event)" />
            </div>
        </div>
        <div class="wrap-row-ddl"
            v-if="isInitSuccess && isHaveBirthdate">
            <div class="wrap-ddl">
                <div class="wrap-ddl-disable">
                    <div>{{dayInput}}</div>
                    <img src="@/assets/icon/ic-arrow-gray-disabled.svg" alt="">
                </div>
                
            </div>
            <div class="wrap-ddl">
                <div class="wrap-ddl-disable">
                    <div>{{monthInput}}</div>
                    <img src="@/assets/icon/ic-arrow-gray-disabled.svg" alt="">
                </div>
            </div>
            <div class="wrap-ddl">
                <div class="wrap-ddl-disable">
                    <div>{{getYear()}}</div>
                    <img src="@/assets/icon/ic-arrow-gray-disabled.svg" alt="">
                </div>
            </div>
        </div>
        <div class="wrap-error-txt"
             v-if="isShowError"
             v-show="isSubmitted && !errorInfo.isValid">
            {{errorInfo.msg}}
        </div>
    </div>
</template>
<script>
// helper
import DatetimeHelper from "@/helper/DatetimeHelper.js";
import Locale from "@/helper/locale/locale.js";
import Util from "@/helper/Utility.js";
// components
import InputDropdown from "./Dropdown.vue";
export default {
    name: 'BirthDateInput',
    components: {
        InputDropdown
    },
    props: {
        // v-model
        value: Date,
        // props
        addClass: String,
        errorInfo: Object,
        inputId: String,
        inputLbl: Object,
        isShowError: Boolean,
        isSubmitted: Boolean,
        isRegister: Boolean,
        isDisabled: Boolean,
    },
    data: function () {
        return {
            id: '',
            label: '',
            content: this.value,
            customClass: '',
            warning: '',
            notice: '',
            isInitSuccess: false,
            isShowDay: false,
            isHaveBirthdate: false,

            dateValue: {
                day: '',
                month: '',
                year: ''
            },

            errorInfoDay: { isValid: false, msg: '' },
            errorInfoMonth: { isValid: false, msg: '' },
            errorInfoYear: { isValid: false, msg: '' },
            ddlInputClass: 'ddl-date-input',

            dayList: [],
            monthList: [],
            yearList: [],

            dayInput: '',
            monthInput: '',
            yearInput: ''
        };
    },
    created: function () {
        this.setDayList();
        this.setMonthList();
        this.setYearList();
    },
    mounted: function () {
        this.id = this.inputId;
        this.label = this.inputLbl.name || '';
        this.placeholder = this.inputLbl.placeholder || 'Placeholder';
        this.minLength = this.inputMinLength || null;
        this.maxLength = this.inputMaxLength || null;
        this.customClass = this.addClass || '';
        this.warning = this.inputLbl.warning || '';
        this.notice = this.inputLbl.notice || '';

        this.setDateInitial();
        this.validateInput();

        this.isInitSuccess = true;
        this.isShowDay = true;
    },
    methods: {
        //#region setup
        setDayList: function() {
            var day = [];
            for (var i=1 ; i<= 31 ; i++) {
                var d = (i < 10) ? '0' + i : '' + i ;
                day.push({
                    value: i+'',
                    text: d
                });
            }
            this.dayList = day;
        },
        setMonthList: function () {
            var lbl = Locale.getLbl();
            var months = lbl.date.month_full;
            var list = [];
            for (var i in months) {
                var index = parseInt(i, 10) + 1 + '';
                var text = index.padStart(2, '0');
                list.push({
                    value: index,
                    text: text,
                });
            }
            this.monthList = list;
        },
        setYearList: function () {
            var currentYear = parseInt(new Date().getFullYear(), 10);
            var yearText = currentYear;
            var localeCode = Locale.getLocaleCode();
            var yearList = [];
            if (localeCode == 1054)
                yearText = yearText + 543;

            for (var i = 0 ; i < 100 ; i++) {
                yearList.push({
                    value: currentYear-i + '',
                    text: yearText-i + '',
                });
            }
            this.yearList = yearList;
        },
        setDateInitial: function() {
            if (Util.isEmptyStr(this.value)) return;
     
            var d = this.content.getDate();
            var m = this.content.getMonth() + 1;
            var y = this.content.getFullYear();

            d = (d < 10) ? '0' + d : '' + d;
            m = (m < 10) ? '0' + m : '' + m;
            this.dayInput = d + '';
            this.monthInput = m + '';
            this.yearInput = y + '';

            this.isHaveBirthdate = true;
        },
        //#endregion setup
        //#region event dropdown
        onDayChange: function (date) {
             this.dateValue.day = date;
            this.setDateOnChange();
        },
        onMonthChange: function (month) {
            this.dateValue.month = month;
            this.setDateOnChange();
        },
        onYearChange: function (year) {
            this.dateValue.year = year;
            this.setDateOnChange();
        },
        setDateOnChange: function () {
            this.setDateIfNotValid();
            this.validateInput();
            if (this.dateValue.year == '' || this.dateValue.month == '' || this.dateValue.day == '') {
                return;
            }

            var m = this.dateValue.month - 1;
            var datetime = new Date(this.dateValue.year, m, this.dateValue.day);
            var timestamp = DatetimeHelper.convertDateToTimeStampUnix(datetime)
            var formated = DatetimeHelper.dateIsoFormat(datetime);
            var output = {
                datetime: datetime,
                timestamp: timestamp,
                formated: formated,
            };
            // this.$emit('onDateChange', output);

            this.content = datetime;
            this.$emit('input', datetime);
            this.$emit('onDateChange', output);
        },
        setDateIfNotValid: function() {
            if (this.dayInput == '' || this.monthInput == '' || this.yearInput == '') {
                return;
            }
            // Util.log("date", this.yearInput +"-"+ this.monthInput +"-"+ this.dayInput);
            if (!DatetimeHelper.isDatetimeValid(this.yearInput, this.monthInput, this.dayInput)) {
                var lastDate = DatetimeHelper.getEndOfMonth(this.yearInput, this.monthInput);
                this.dayInput = lastDate.getDate()+"";
                // console.log(lastDate);
                this.refreshInput();
            }
        },
        //#endregion event dropdown
        //#region method
        refreshInput: function() {
            this.isInitSuccess = false;
            this.$nextTick(() => {
                // this.setDayList();
                this.isInitSuccess = true;
            });
        },
        validateInput: function() {
            // if(!this.inputLbl) return false;
            //Set default.
            this.errorInfo.isValid = true;
            this.errorInfo.msg = '';

            //Required
            if (this.inputLbl.required &&
                (this.dayInput == '' || this.monthInput == '' || this.yearInput == '')
            ) {
                this.errorInfo.isValid = false;
                this.errorInfo.msg = this.inputLbl.required;
                return false;
            }

            return true;
        },
        //#endgion method
        //#region util
        getDay: function () {
            return this.content.getDate();
        },
        getMonth: function () {
            return this.content.getMonth();
        },
        getYear: function () {
            let y = this.content.getFullYear();
            if (Locale.getLocaleCode() == 1054)
                y += 543;

            return y;
        }
        //#endregion util
    }
}
</script>
<style lang="scss">
$url-dropdown-icon: url('../../assets/icon/ic-arrow-down-gray.svg');
@import "@/style/base/base.scss";
@import "@/style/Input/Dropdown.scss";
.wrap-row-ddl.wrap-row-ddl-error {
    .wrap-ddl .ddl-wrapper {
        margin-bottom: 0;

        .ddl-input .btn-ddl-input {
            border: 1px solid $input-error-color;
        }
    }
}
</style>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/Input/Text.scss";
.wrap-row-ddl {
    @extend %display-flex;

    .wrap-ddl {
        flex: 1 1 auto;

        &:nth-child(1) {
            padding-right: 5px;
        }

        &:nth-child(2) {
            padding-left: 5px;
            padding-right: 5px;
        }

        &:nth-last-child(1) {
            padding-left: 5px;
        }

        .wrap-ddl-disable {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 8px 16px;
            height: 45px;
            border: 1px solid $a-gray-C4C4C4;
            border-radius: 100px;
            background: $a-gray-E8E8E8;
            // font
            color: $gray-A0A0A0;
            font-family: $regular;
            font-size: 1.6rem;
            line-height: 50px;
            text-align: center;
        }
    }
}

.wrap-error-txt {
    width: 100%;
    margin-top: 8px;
    //font
    color: $a-red-C03744;
    font-size: 1.3rem;
    text-align: center;
}
.wrap-input {
    @extend %input-base;

    .input-label {
        color: $a-gray-575757;
        font-size: 1.5rem;
    }
}
.text-req {
    color: $a-red-C03744;
}
.text-warning-register { 
    color: $a-gray-A0A0A0;
    font-size: 1.25rem;
}

.text-notice {
    .star {
        color: $input-error-color;
    }
    .notice {
        color: #A0A0A0;
        font-size: 20px;
    }
}
</style>
